import { useEffect, useRef } from 'react';
import { FormRendererAPIType } from 'components/common/form';
import { ComponentSettingsKpiChartMeasureField, getMeasureFieldOptionForFormUId } from '@report-content';

// Turning the option on with no split measure selected splits the primary measure
export default function useSplitByFilterDefault(
    form: FormRendererAPIType,
    measureFields: Array<ComponentSettingsKpiChartMeasureField>,
) {
    const splitByFilterValues = form.hookFormWatch('split_by_filter_values');
    const prevSplitByFilterValues = useRef(splitByFilterValues);
    useEffect(() => {
        const wasEnabled = prevSplitByFilterValues.current == 'Y';
        prevSplitByFilterValues.current = splitByFilterValues;
        if (wasEnabled || splitByFilterValues != 'Y') {
            return;
        }
        const isOn = (field: ComponentSettingsKpiChartMeasureField, option: string) =>
            form.hookFormGetValues(getMeasureFieldOptionForFormUId(field, option)) == 'Y';
        if (measureFields.some((f) => isOn(f, 'is_split_by_filter'))) {
            return;
        }
        const primary = measureFields.find((f) => isOn(f, 'is_primary')) ?? measureFields[0];
        if (primary) {
            form.hookFormSetValue(getMeasureFieldOptionForFormUId(primary, 'is_split_by_filter'), 'Y');
        }
    }, [splitByFilterValues]);
}
